const _ = require('lodash');

function AnimationEventFactory(animEvent) {

    const vendorPrefix = ['webkit', 'moz', 'MS', 'o', ''];

    function prefixEvent(element, type, callback) {
      for (let p = 0; p < vendorPrefix.length; p++) {
        if (!vendorPrefix[p]) type = type.toLowerCase();
        element.addEventListener(vendorPrefix[p] + type, callback, false);
      }
    }

    return ($parse) => {
        return {
            restrict: 'A',
            compile() {
                return {
                    post(scope, element, attr) {
                        const cb = $parse(attr[animEvent.directiveName])(scope);
                        if (!_.isUndefined(cb)) {
                            prefixEvent(element[0], animEvent.eventName, cb);
                        }
                    }
                };
            }
        };
    };
}

module.exports = AnimationEventFactory;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/animation-events/animation-event-factory.js
 **/